const config = {
  mainTitle: 'Party Themes',
  subHeading: 'A page to see Party Themes. (Note: Price is *100 here)',
  titleIcon: 'IosBookmarksOutline'
}

export default config
